import fscreen from 'fscreen';
import { isPresent } from './cypress';

export const safeExitFullscreen = () => {
  !isPresent &&
    fscreen.fullscreenEnabled &&
    fscreen.fullscreenElement &&
    fscreen.exitFullscreen();
};
